import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaqsComponent } from './faqs.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { LayoutModule } from 'src/app/layout/layout.module';



@NgModule({
  declarations: [
    FaqsComponent
  ],
  imports: [
    CommonModule,
		RouterModule.forChild([
		  {
			path: '',
			component: FaqsComponent
		  },
		]),
		LayoutModule,
		TranslateModule,
		FormsModule
  ]
})
export class FaqsModule { }
